// extracted by mini-css-extract-plugin
export default {"input":"AnswerFeedbackModal_input__m9qPU","ratings":"AnswerFeedbackModal_ratings__hcnjQ"};